import type { PropsWithChildren } from 'react'
import { useAuth } from '@steelhouse/auth-next/client'

export const AuthLoading = ({ children }: PropsWithChildren) => {
  const { isLoaded } = useAuth()

  return !isLoaded ? children : null
}
